export default __webpack_public_path__ + "static/ellipse_left-5cde1966ea7bbe1b90c47ef35d0f6e2f.png";